import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { Configurator } from "./features/configurator/Configurator";
import { ReferralLinkBuilder } from "./features/referral/ReferralLinkBuilder";
import { AppHeader } from "./app/AppHeader";
import { ROUTES } from "./app/routes";

export function App() {
  return (
    <BrowserRouter basename={import.meta.env.BASE_URL}>
      <div className="min-h-full">
        <AppHeader />
        <Routes>
          <Route path={ROUTES.widget} element={<Configurator />} />
          <Route path={ROUTES.referral} element={<ReferralLinkBuilder />} />
          <Route path="*" element={<Navigate to={ROUTES.widget} replace />} />
        </Routes>
      </div>
    </BrowserRouter>
  );
}
